/**
 * @param {string} folderPath
 * @returns {StageDO}
 */

export const getStageDOFromFolderPath = async (folderPath) => {
  const regex = /.*_STAGE_(\d+)\/$/i;
  const match = folderPath.match(regex);
  if (match) {
    return {
      stageKey: match[1],
      stageNumber: parseInt(match[1], 10),
    };
  }
  return undefined
};

export const getStageFileDOFromFilePath = async (filePath) => {
  const regex = /.*_STAGE_(\d+).*__(LOWER|UPPER)__.*$/i;
  const match = filePath.match(regex);
  if (match) {
    const stageNumber = parseInt(match[1], 10);
    const toothGumType = match[2];
    return {
      filePath,
      stageNumber,
      toothGumType
    };
  }
  return undefined
};
